import { Box, Heading4, Text } from '@origin-digital/style-guide';

import React from 'react';

import { FormRowProps } from './FormRow.types';

const FormRow: React.StatelessComponent<FormRowProps> = ({ ...props }: FormRowProps): JSX.Element => {
  const { children, content, byline, rowMarginBottom } = props;

  return (
    <React.Fragment>
      {!byline &&
        content.heading && (
          <Box marginBottom={4}>
            <Heading4 text={content.heading} align="left" />
          </Box>
        )}
      {byline &&
        content.heading && (
          <React.Fragment>
            <Heading4 text={content.heading} align="left" />
            <Box marginBottom={4} marginTop={2}>
              <Text size={'sm'}>{content.byline}</Text>
            </Box>
          </React.Fragment>
        )}
      <Box marginBottom={rowMarginBottom}>{children}</Box>
    </React.Fragment>
  );
};

export { FormRow as default };
